// SearchFilter.js component
import React, { useState } from "react";
import { addDays } from "date-fns";
import {
  IconButton,
  ButtonToolbar,
  Button,
  Panel,
  DateRangePicker,
  SelectPicker,
  Input,
  Checkbox,
} from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import styles from "./SearchFilter.module.css";
import { useInvoicesHeader } from "./useInvoicesHeader";

const dateFieldOptions = [
  { label: "Invoice Date", value: "invoiceIssueDate" },
  { label: "Due Date", value: "invoiceDueDate" },
  { label: "Approval Date", value: "invoiceApprovedDate" },
  { label: "Paid Date", value: "invoicePaidDate" },
  { label: "Accounting System Entry Date", value: "invoicePostedDate" },
];

function SearchFilter() {
  const [open, setOpen] = useState(false);
  //const [dateField, setDateField] = useState("invoiceIssueDate");
  //const [dateRange, setDateRange] = useState(null);

  let {
    filter,
    dateFilterTitle,
    dateFilterName,
    dateFilterRange,
    setFilterNameField,
    setDateFilterRange,
    clearDateFilterRange,
    applyDateFilter,
    checkedNotPosted,
    onClickNotPosted,
  } = useInvoicesHeader();

  const handleFilterClick = () => {
    console.log("handleFilterClick");
    setOpen(!open);
  };

  const handleApplyFilter = () => {
    // Apply the filters
    applyDateFilter();
    console.log("Applied filters:", filter);
    setOpen(false);
  };

  const handleClearFilter = () => {
    setFilterNameField("noInvoiceFilter");
    clearDateFilterRange();
    setOpen(false);
  };
 

  const startOfUTCDate = (date) => {
    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0,
        0
      )
    );
  };

  const endOfUTCDate = (date) => {
    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        23,
        59,
        59,
        999
      )
    );
  };

  const now = new Date();
  const todayStart = startOfUTCDate(now);
  const todayEnd = endOfUTCDate(now);

  const yesterday = new Date(now);
  yesterday.setUTCDate(now.getUTCDate() - 1);
  const yesterdayStart = startOfUTCDate(yesterday);
  const yesterdayEnd = endOfUTCDate(yesterday);

  const last7Start = new Date(now);
  last7Start.setUTCDate(now.getUTCDate() - 7);
  const last7StartUTC = startOfUTCDate(last7Start);

  const last30Start = new Date(now);
  last30Start.setUTCDate(now.getUTCDate() - 30);
  const last30StartUTC = startOfUTCDate(last30Start);

  const firstDayThisMonth = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)
  );
  const lastDayThisMonth = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 0, 23, 59, 59, 999)
  );

  const firstDayLastMonth = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1)
  );
  const lastDayLastMonth = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 0, 23, 59, 59, 999)
  );

  const predefinedRanges = [
    {
      label: "Today",
      value: [todayStart, todayEnd],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [yesterdayStart, yesterdayEnd],
      placement: "left",
    },
    {
      label: "Last 7 Days",
      value: [last7StartUTC, todayEnd],
      placement: "left",
    },
    {
      label: "Last 30 Days",
      value: [last30StartUTC, todayEnd],
      placement: "left",
    },
    {
      label: "This Month",
      value: [firstDayThisMonth, lastDayThisMonth],
      placement: "left",
    },
    {
      label: "Last Month",
      value: [firstDayLastMonth, lastDayLastMonth],
      placement: "left",
    },
  ];

  return (
    <div className={styles.searchFilterContainer}>
      <ButtonToolbar style={{ width: 360 }}>
        <Button
          onClick={handleFilterClick}
          className={styles.activeFilterButton}
          style={{ width: 347 }}
        >
          {dateFilterTitle}
        </Button>
      </ButtonToolbar>

      {open && (
        <Panel className={styles.filterPanel} bordered>
          <div className={styles.filterTitle}>Filter by Date</div>

          <div className={styles.filterRow}>
            <SelectPicker
              searchable={false}
              data={dateFieldOptions}
              value={dateFilterName}
              onChange={setFilterNameField}
              cleanable={false}
              style={{ width: 360 }}
            />
          </div>

          <div className={styles.filterRow}>
            <DateRangePicker
              isoWeek
              ranges={predefinedRanges}
              value={dateFilterRange}
              onChange={setDateFilterRange}
              cleanable={false}
              format="dd/MM/yyyy"
              placeholder="Select date range"
              style={{ width: "100%", zIndex: 100 }}
            />
          </div>
          {dateFilterName !== "invoicePostedDate" && (
            <div className={styles.filterCheckbox}>
              <Checkbox
                checked={checkedNotPosted}
                onClick={() => {
                  onClickNotPosted(checkedNotPosted);
                }}
                onChange={() => {}}
                style={{ marginTop: -4 }}
              />
              <span className={styles.filterCheckboxLabel}>
                Search 'Not Posted' invoices
              </span>
            </div>
          )}
          <div className={styles.filterActions}>
            <Button appearance="default" onClick={handleClearFilter}>
              Clear
            </Button>
            <Button appearance="primary" onClick={handleApplyFilter}>
              Apply Filter
            </Button>
          </div>
        </Panel>
      )}
    </div>
  );
}

export default SearchFilter;
